finderApp.directive('niPriceTag', ['productService', 'finderBasePath', '$timeout', function(productService, finderBasePath, $timeout) {
    "use strict";

    return {
        restrict: 'EA',
        templateUrl: function($elem, $attr){
            return finderBasePath + 'template/ni-price-tag-' + ($attr.mode || 'default') + '.html';
        },
        scope: {
            sku: '=',
            format: '@'
        },
        controller: function PriceTagController($scope, $element) {

            var isHeader = $element.closest('.content-header').length;

            $scope.$watch('format', function(format) {
                $scope.format = format || 'regular';
            });

            $scope.$watch('sku', function(sku) {
                if (sku === '' || !sku) {
                    $scope.price = null;
                } else {
                    productService.getPrice(sku)
                        .then(function(price) {
                            $scope.price = price;
                            if(price.bundle && isHeader){
                              document.querySelector('.content-header-logo a').classList.add('bundle-content-header-label');
                            }
                        });
                }
            });

            $scope.openFinancingModal = function (data) {
              var link = '/shop-information/paypal-installments-modal/';
              if(!data.min_price) {
                link = '/shop-information/paypal-credit-modal/';
              }

              jQuery('<a>').attr('href', '/' + Util.getLang() + link + '?type=' + Util.ajaxDoktype)
                .magnificPopup({
                  mainClass: 'mfp-fade',
                  type: 'ajax',
                  closeBtnInside: true,
                  tLoading: '',
                  callbacks: {
                    ajaxContentAdded: function () {
                      window.initRichContent();
                    }
                  }
                }).click();

              Track.analyticsEvent('PayPal Installment Modal', data.min_price ? 'DE' : 'US', 'Variant');

            };
        }
    };
}]);
